import { gql } from '@apollo/client'

export const DELETE_TRANSACTION = gql`
  mutation DeleteTransaction($id: Int!) {
    delete_transactions_by_pk(id: $id) {
      id
    }
  }
`;